import {
  createMapGridHelper
} from './portal-map-grid.js'

const initializePortalMap = function ({
  $ = window.jQuery,
  L = window.L,
  $leafletmap = $('[data-leafletmap]'),
  $body = $('body'),
  db = {},
  store = {},
  fnT = function (key) { return String(key || '') },
  fnLayerFilterAll = function () {},
  fnBindPolygonCreateClick = function () {},
  fnApplyMyLocationLatLng = function () {},
  fnTryBrowserMyLocationFallback = function () {},
  fnGetMyLocationActive = function () { return false },
  fnSelectClear = function () {},
  fnSelectToggle = function () {},
  fnPointInPolygon = function () { return false },
  fnGetImportMissionState = function () { return null },
  fnGetImportSeekMode = function () { return false },
  fnSetImportSeekMode = function () {},
  fnSetImportSeekDrawActive = function () {},
  fnSetImportSeekDrawLine = function () {},
  fnGetImportSeekAxisCallback = function () { return null },
  fnSetImportSeekAxisCallback = function () {},
  fnGetImportSelectMode = function () { return false },
  fnSetImportSelectMode = function () {},
  fnOnImportSelectModeResetUi = function () {},
} = {}) {

  let map = null
  let notamItems = null
  let drawnItems = null
  let importItems = null
  let importLineItems = null
  let tiffDemItems = null
  let tiffOrthoItems = null
  let gridHelper = null
  let gridLayer = null
  let fnUpdateGridOverlayIndicator = function () {}

  const fnTF = function (key, vars, fallback) {
    const text = String(fnT(key) || fallback || key || '')
    const data = (vars && typeof vars === 'object') ? vars : {}
    return text.replace(/\{([a-zA-Z0-9_]+)\}/g, function (_match, token) {
      return Object.prototype.hasOwnProperty.call(data, token) ? String(data[token]) : ''
    })
  }

  $leafletmap.each(function () {
    map = L.map($leafletmap.get(0))

    if (db.settings && db.settings.center && db.settings.zoom) {
      map.setView(db.settings.center, db.settings.zoom)
    } else {
      ;(function (go) {
        switch (go) {
          case 'hu':
            map.setView([47.30165045033799, 19.31095551982859], 8)
            break
          case 'eu':
            map.setView([46.195430295267734, 19.490300092154072], 5)
            break
        }
      })('hu')
    }

    notamItems = L.featureGroup().addTo(map)
    drawnItems = L.featureGroup().addTo(map)
    importItems = L.featureGroup().addTo(map)
    importLineItems = L.featureGroup().addTo(map)
    if (!map.getPane('tiffPane')) {
      map.createPane('tiffPane')
    }
    const tiffPane = map.getPane('tiffPane')
    if (tiffPane) {
      tiffPane.style.zIndex = '350'
      tiffPane.style.pointerEvents = 'none'
    }
    tiffDemItems = L.layerGroup().addTo(map)
    tiffOrthoItems = L.layerGroup().addTo(map)
    gridHelper = createMapGridHelper({
      $: $,
      L: L,
      map: map,
      $body: $body,
      db: db,
      store: store,
      fnT: fnT,
      fnGetImportMissionState: fnGetImportMissionState,
      fnOnStateChange: function () {
        fnUpdateGridOverlayIndicator()
      }
    })
    gridLayer = gridHelper && gridHelper.layer ? gridHelper.layer : null

    const baseMapsA = {
      'Esri (Sat.)': (L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
        attribution: 'Esri & OpenStreetMap Contributors',
        id: 'MapID', maxZoom: 30, maxNativeZoom: 19, tileSize: 512, zoomOffset: -1
      })),
      'Google (Terrain)': (L.tileLayer('http://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}', {
        attribution: 'Google Maps & OpenStreetMap Contributors',
        maxNativeZoom: 22,
        maxZoom: 30,
        subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
      })),
      'Google (Street)': (L.tileLayer('http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
        attribution: 'Google Maps & OpenStreetMap Contributors',
        maxNativeZoom: 22,
        maxZoom: 30,
        subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
      })),
      'Google (Sat.)': (L.tileLayer('http://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}', {
        attribution: 'Google Maps & OpenStreetMap Contributors',
        maxNativeZoom: 21,
        maxZoom: 30,
        subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
      })),
      'Google (Hybrid)': (L.tileLayer('http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}', {
        attribution: 'Google Maps & OpenStreetMap Contributors',
        maxNativeZoom: 21,
        maxZoom: 30,
        subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
      })),
      'OSM (Street)': (L.tileLayer('https://{s}.tile.osm.org/{z}/{x}/{y}.png', {
        attribution: 'Map data &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>',
        drawControl: true,
        maxNativeZoom: 19,
        maxZoom: 30
      }))
    }
    const baseMaps = {}
    const baseMapToLoad = (db.settings && db.settings.baseMap ? db.settings.baseMap : 'OSM (Street)')
    $.each(baseMapsA, function (key, val) {
      baseMaps[key] = val
      if (baseMapToLoad === key) {
        baseMaps[key].addTo(map)
      }
    })

    const layerControlA = L.control.layers(baseMaps, {}, { position: 'topleft', collapsed: false, autoZIndex: true }).addTo(map)
    const layerControlB = L.control.layers({}, {}, { position: 'topright', collapsed: false, autoZIndex: true }).addTo(map)
    const gridOverlayLabelHtml = '<span data-grid-overlay-label-root data-bs-toggle="tooltip" data-bs-placement="right"><span data-grid-overlay-label-text>' + fnT('grid.overlay_label') + '</span><span data-grid-overlay-label-status></span></span>'

    layerControlB._onInputClick = function () {}
    const fnToggleLayerControlB = function (enabled) {
      if (enabled) {
        map.addControl(layerControlB)
      } else {
        map.removeControl(layerControlB)
      }
    }

    layerControlA
      .addOverlay(gridLayer, gridOverlayLabelHtml)
      .addOverlay(notamItems, 'NOTAM')
      .addOverlay(drawnItems, 'Rajzolt')
      .addOverlay(importLineItems, fnT('layer.import'))
      .addOverlay(tiffDemItems, fnT('geotiff.overlay_dem'))
      .addOverlay(tiffOrthoItems, fnT('geotiff.overlay_ortho'))
    const fnFormatGridZoomValue = function (zoomValue) {
      const zoomNumber = Number(zoomValue)
      if (!Number.isFinite(zoomNumber)) return '?'
      return String(Math.round(zoomNumber * 10) / 10).replace(/\.0$/, '')
    }
    const fnGetGridOverlayLabelRoot = function () {
      const container = (layerControlA && typeof layerControlA.getContainer === 'function')
        ? layerControlA.getContainer()
        : null
      return container ? $(container).find('[data-grid-overlay-label-root]').first() : $()
    }
    const fnResetGridOverlayTooltip = function ($node) {
      if (!$node || !$node.length) return
      const el = $node.get(0)
      const bootstrapObj = (typeof window !== 'undefined') ? window.bootstrap : null
      if (!bootstrapObj || !bootstrapObj.Tooltip) return
      const instance = bootstrapObj.Tooltip.getInstance(el)
      if (instance) instance.dispose()
    }
    const fnBuildGridOverlayStatusHtml = function (zoomState) {
      const iconHtmlByState = {
        visible:  '<i class="fa-solid fa-magnifying-glass fa-fw"></i><i class="fa-solid fa-circle-check fa-fw text-success"></i>',
        too_low:  '<i class="fa-solid fa-magnifying-glass-plus fa-fw"></i><i class="fa-solid fa-triangle-exclamation fa-fw text-warning"></i>',
        too_high: '<i class="fa-solid fa-magnifying-glass-minus fa-fw"></i><i class="fa-solid fa-triangle-exclamation fa-fw text-warning"></i>',
        unknown:  '<i class="fa-solid fa-magnifying-glass fa-fw"></i><i class="fa-solid fa-circle-question fa-fw text-secondary"></i>'
      }
      const iconHtml = Object.prototype.hasOwnProperty.call(iconHtmlByState, zoomState)
        ? iconHtmlByState[zoomState]
        : iconHtmlByState.unknown
      return ' (zoom ' + iconHtml + ')'
    }
    fnUpdateGridOverlayIndicator = function () {
      const $root = fnGetGridOverlayLabelRoot()
      if (!$root.length || !gridHelper || typeof gridHelper.getVisibilityState !== 'function') return
      const visibilityState = gridHelper.getVisibilityState()
      const currentZoom = fnFormatGridZoomValue(visibilityState.currentZoom)
      const titleKey = !visibilityState.overlayEnabled
        ? 'grid.overlay_zoom_disabled'
        : ({
            visible: 'grid.overlay_zoom_visible',
            too_low: 'grid.overlay_zoom_too_low',
            too_high: 'grid.overlay_zoom_too_high'
          }[visibilityState.zoomState] || 'grid.overlay_zoom_disabled')
      const titleText = fnTF(titleKey, {
        currentZoom: currentZoom,
        minZoom: visibilityState.minZoom,
        maxZoom: visibilityState.maxZoom
      })
      $root.attr('data-bs-title', titleText)
      $root.attr('title', titleText)
      $root.find('[data-grid-overlay-label-status]').html(fnBuildGridOverlayStatusHtml(visibilityState.zoomState))
      fnResetGridOverlayTooltip($root)
    }
    const fnSetOverlayByCheckbox = function (layer, enabled) {
      const layerId = String(L.Util.stamp(layer))
      const input = Array.from(layerControlA._layerControlInputs || []).find(function (el) { return String(el.layerId) === layerId })
      if (!input) {
        if (enabled) {
          layer.addTo(map)
        } else {
          layer.removeFrom(map)
        }
        return
      }
      if (input.checked !== enabled) {
        input.click()
      }
    }
    const fnSaveOverlayVisible = function () {
      if (!db.settings || typeof db.settings !== 'object') db.settings = {}
      db.settings.overlayVisible = {
        grid: !!(gridLayer && map.hasLayer(gridLayer)),
        notam: map.hasLayer(notamItems),
        drawn: map.hasLayer(drawnItems),
        import: map.hasLayer(importLineItems),
        tiffDem: map.hasLayer(tiffDemItems),
        tiffOrtho: map.hasLayer(tiffOrthoItems)
      }
      if (store && typeof store.setAll === 'function') {
        void store.setAll(db)
      }
    }
    const fnRestoreOverlayVisible = function () {
      const vis = (db.settings && db.settings.overlayVisible) ? db.settings.overlayVisible : {}
      ;[
        { layer: gridLayer, enabled: vis.grid === true },
        { layer: notamItems, enabled: vis.notam !== false },
        { layer: drawnItems, enabled: vis.drawn !== false },
        { layer: importLineItems, enabled: vis.import !== false },
        {
          layer: tiffDemItems,
          enabled: (typeof vis.tiffDem === 'undefined') ? (vis.tiff !== false) : (vis.tiffDem !== false)
        },
        {
          layer: tiffOrthoItems,
          enabled: (typeof vis.tiffOrtho === 'undefined') ? (vis.tiff !== false) : (vis.tiffOrtho !== false)
        }
      ].forEach(function (item) {
        if (!item.layer) return
        if (item.layer === notamItems) {
          fnSetOverlayByCheckbox(notamItems, item.enabled)
          return
        }
        if (item.enabled) {
          item.layer.addTo(map)
        } else {
          item.layer.removeFrom(map)
        }
      })
    }
    fnUpdateGridOverlayIndicator()
    setTimeout(function () {
      fnRestoreOverlayVisible()
      fnUpdateGridOverlayIndicator()
    }, 100)
    map.on('overlayadd', function (event) {
      if (event.layer === notamItems) {
        fnToggleLayerControlB(true)
        fnLayerFilterAll()
      }
      if ([gridLayer, notamItems, drawnItems, importLineItems, tiffDemItems, tiffOrthoItems].includes(event.layer)) {
        fnSaveOverlayVisible()
      }
    })
    map.on('overlayremove', function (event) {
      if (event.layer === notamItems) {
        fnToggleLayerControlB(false)
        fnLayerFilterAll()
      }
      if ([gridLayer, notamItems, drawnItems, importLineItems, tiffDemItems, tiffOrthoItems].includes(event.layer)) {
        fnSaveOverlayVisible()
      }
    })
    fnToggleLayerControlB(map.hasLayer(notamItems))

    $.each(window.airSpaceTypes, function (id, asp) {
      const lgp = L.layerGroup()
      window.airSpaceTypes[id].overlay = lgp
      const overlay = {
        id: id,
        short: asp.short
      }
      const label = "<span data-overlay='" + JSON.stringify(overlay) + "'>" + asp.short + '<small class="d-none" data-leaf-checkbox-label> - ' + asp.hu + '</small></span>'
      window.airSpaceTypes[id].layerControl = layerControlB.addOverlay(lgp, label)
    })

    const fnFormatScaleZoomValue = function (zoomValue) {
      const zoomNumber = Number(zoomValue)
      if (!Number.isFinite(zoomNumber)) return ''
      return String(Math.round(zoomNumber * 10) / 10).replace(/\.0$/, '')
    }

    const fnUpdateScaleLineZoomLabel = function (scaleControl) {
      if (!scaleControl || typeof scaleControl.getContainer !== 'function') return
      const scaleContainer = scaleControl.getContainer()
      if (!scaleContainer || !scaleContainer.firstElementChild) return
      const scaleLine = scaleContainer.firstElementChild
      scaleLine.setAttribute('data-portal-map-scale-line', '1')
      const baseLabel = String(scaleLine.textContent || '').replace(/\s*\([^()]*\)\s*$/, '').trim()
      const zoomLabel = fnFormatScaleZoomValue(map && typeof map.getZoom === 'function' ? map.getZoom() : null)
      if (!baseLabel || !zoomLabel) return
      scaleLine.textContent = baseLabel + ' (' + zoomLabel + ')'
    }

    map.zoomControl.remove()
    const scaleControl = L.control.scale({
      imperial: false,
      metric: true,
      maxWidth: 200
    }).addTo(map)
    fnUpdateScaleLineZoomLabel(scaleControl)
    map.on('zoom', function () {
      fnUpdateScaleLineZoomLabel(scaleControl)
    })
    map.on('zoomend moveend', function () {
      window.setTimeout(function () {
        fnUpdateScaleLineZoomLabel(scaleControl)
      }, 0)
    })

    map.addControl(new L.Control.Draw({
      edit: {
        featureGroup: drawnItems,
        poly: {
          allowIntersection: false
        }
      },
      draw: {
        polygon: {
          allowIntersection: false,
          showArea: true
        }
      }
    }))

    map.on(L.Draw.Event.CREATED, function (event) {
      console.log(event)
      if (fnGetImportSeekMode() && event.layerType === 'polyline') {
        fnSetImportSeekMode(false)
        fnSetImportSeekDrawActive(false)
        fnSetImportSeekDrawLine(null)
        const cb = fnGetImportSeekAxisCallback()
        fnSetImportSeekAxisCallback(null)
        if (typeof cb === 'function') {
          cb(event.layer)
        }
        return
      }
      if ((event.layerType === 'rectangle' || event.layerType === 'polygon') && fnGetImportSelectMode()) {
        fnSelectClear()
        const missionState = fnGetImportMissionState()
        const allPoints = (missionState && missionState.waypoints) ? missionState.waypoints : []
        if (event.layerType === 'rectangle') {
          const bounds = event.layer.getBounds()
          allPoints.forEach(function (pt) {
            if (pt && pt.marker && bounds.contains(pt.marker.getLatLng())) {
              fnSelectToggle(pt)
            }
          })
        } else {
          const polyLatLngs = event.layer.getLatLngs()
          const ring = polyLatLngs && polyLatLngs.length ? polyLatLngs[0] : []
          allPoints.forEach(function (pt) {
            if (pt && pt.marker && fnPointInPolygon(pt.marker.getLatLng(), ring)) {
              fnSelectToggle(pt)
            }
          })
        }
        fnSetImportSelectMode(false)
        fnOnImportSelectModeResetUi()
        return
      }
      if (event.layerType === 'marker') {
        // Do marker specific actions
      }
      drawnItems.addLayer(event.layer)
      drawnItems.addTo(map)
      fnBindPolygonCreateClick(event.layer)
    })

    map.on('locationfound', function (event) {
      const latlng = event && event.latlng ? event.latlng : null
      if (!latlng) return
      fnApplyMyLocationLatLng(latlng)
    })

    map.on('locationerror', function () {
      if (!fnGetMyLocationActive()) return
      fnTryBrowserMyLocationFallback()
    })

    map.on('moveend', function () {
      if (!db.settings || typeof db.settings !== 'object') db.settings = {}
      db.settings.center = map.getCenter()
      if (store && typeof store.setAll === 'function') {
        void store.setAll(db)
      }
    })

    map.on('zoomend', function () {
      if (!db.settings || typeof db.settings !== 'object') db.settings = {}
      db.settings.zoom = map.getZoom()
      if (store && typeof store.setAll === 'function') {
        void store.setAll(db)
      }
    })
  })

  return {
    map: map,
    notamItems: notamItems,
    drawnItems: drawnItems,
    importItems: importItems,
    importLineItems: importLineItems,
    tiffDemItems: tiffDemItems,
    tiffOrthoItems: tiffOrthoItems,
    gridHelper: gridHelper
  }
}

export {
  initializePortalMap
}
